
import { useState,useEffect } from 'react'
import './styles/UsersAdmin.css'
import Action from '../Action'
import { useFetch } from '../../hooks/useFetch'
import Selector from '../Selector'
const Herramienta1=()=>{
    
    return (
        <div className="main-users-admin">
            <h1 style={{color:'grey'}}>opcion de prueba</h1>
        </div>
    )
}

export default Herramienta1